import XHR from '@/api'
export default {
  data: () => ({
    // 设备类型
    deviceType: '',
    listen: null,
    videoTitle: ''
  }),
  created () {
    this.deviceType = this.getType()
  },
  computed: {},
  methods: {
    // 判断是什么端
    getType () {
      const uaCase = navigator.userAgent
      if (/MicroMessenger/i.test(navigator.userAgent)) {
        return 'weixin'
      } else if (uaCase.toLowerCase().indexOf('360che') >= 0) {
        return 'app'
      } else if (/phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(navigator.userAgent)) {
        return 'm'
      } else {
        return 'pc'
      }
    },
    // ios微信失去焦点问题
    onBlur () {
      const timer = setTimeout(() => {
        const scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
        timer && clearTimeout(timer)
      }, 100)
    },
    // 微信注册
    wxConfig () {
      const wx = window.wx
      const href = window.location.href.split('#')[0]
      const json = {
        url: href
      }
      XHR.getWechatJsSdk(json).then(res => {
        // 注册微信信息
        const data = res.data
        try {
          wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: [
              // 分享操作接口
              'onMenuShareTimeline',
              'onMenuShareAppMessage'
            ]
          })
        } catch (e) { }
      })
    },
    // 分享页面
    wxsharePage () {
      if (this.deviceType === 'weixin') {
        const wx = window.wx
        // 获取cookie 加微信埋点
        const udstatistics = document.cookie.match(/udstatistics=([^;$]+)/)
        const hrefWxId = location.href.match(/wxzfr=([^&$]+)/)
        if (udstatistics && udstatistics[1]) {
          if (hrefWxId && hrefWxId[1]) {
            window.shareLink.url = window.shareLink.url.replace(hrefWxId[1], `wx_${udstatistics[1]}`)
          } else {
            window.shareLink.url = window.shareLink.url + '?wxzfr=wx_' + udstatistics[1]
          }
        }
        wx.ready(() => {
          this.sendAnalytics('配件新零售招商专题活动', '点击分享', '')
          wx.onMenuShareTimeline({
            title: window.shareLink.title, // 分享标题
            desc: window.shareLink.desc, // 分享描述
            link: window.shareLink.url, // 分享链接
            imgUrl: window.shareLink.imgUrl, // 分享图标
            success: () => {
            }
          })
          wx.onMenuShareAppMessage({
            title: window.shareLink.title, // 分享标题
            desc: window.shareLink.desc, // 分享描述
            link: window.shareLink.url, // 分享链接
            imgUrl: window.shareLink.imgUrl, // 分享图标
            success: () => {
            }
          })
        })
      }
    },
    appShareBtn () {
      if (this.deviceType === 'app') {
        this.sendAnalytics('配件新零售招商专题活动', '点击分享', '')
        window.callNativeMethod('onShowShareButton', {
          isShow: true,
          title: window.shareLink.title, // 分享标题
          desc: window.shareLink.desc, // 分享描述
          link: window.shareLink.url, // 分享链接
          imgUrl: window.shareLink.imgUrl // 分享图标
        })
      }
    },
    // app内分享
    onShare () {
      console.log(window.shareLink)
      this.sendAnalytics('配件新零售招商专题活动', '点击分享', '')
      window.callNativeMethod('onShare', {
        title: window.shareLink.title, // 分享标题
        desc: window.shareLink.desc, // 分享描述
        link: window.shareLink.url, // 分享链接
        imgUrl: window.shareLink.imgUrl // 分享图标
      })
    },
    sendAnalytics (c, a, l) {
      console.log('调用一次埋点')
      try {
        // eslint-disable-next-line
        ga('send', 'event', c, a, l)
      } catch (e) { }
    },
    // 视频播放
    /* eslint-disable */
    playVideo (data, index, id, titBox) {
      if (data && data.length) {
        window.GlobalVideo.distroyAll()
        // eslint-disable-next-line no-new
        new window.GlobalVideo.TxVideo({
          id,
          options: {
            sources: [
              {
                src: data[index].link
              }
            ]
          },
          plugins: [
            new window.GlobalVideoDefaultPlugins.PausedButtonPlugin({
              bgSize: {
                width: 60,
                height: 60
              }
            })
          ]
        })
        titBox && (document.querySelector(titBox) && (document.querySelector(titBox).innerHTML = data[index].title))
        this.videoTitle = data[index].title
        if (!this.listen) {
          setTimeout(() => {
            if (document.querySelector('video')) {
              this.listen = document.querySelector('video').addEventListener('play', (e) => {
                this.sendAnalytics('配件新零售招商专题活动', '播放视频', this.videoTitle)
              })
            }

          }, 600)
        }

      }
    },
    //判断是否为手机号
    isPhoneNum (number) {
      var reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
      return reg.test(number)
    }
  }
}
